import axios from "axios";
import { host } from "../../../helper/config";

const PLUGINS_NAME = "admin-loto-setting";

export const getLotoRegionSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/region/get`,
    {},
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const updateLotoRegionSetting = async (token, config) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/region/update`,
    config,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const getLotoCutoffSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/cutoff/get`,
    {},
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const updateLotoCutoffSetting = async (token, cutoffTimes) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/cutoff/update`,
    { cutoffTimes },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const getLotoChannelSetting = async (token, region) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/channels/get`,
    { region },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const updateLotoChannelSetting = async (token, region, channelIds) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/channels/update`,
    { region, channelIds },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const getLotoIcons = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/icon/get`,
    {},
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const updateLotoIcon = async (token, region, icon) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/icon/update`,
    { region, icon: icon || "" },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};
